import * as faker from 'faker';

import { ReportListItem } from './report-list-item';

export class MockReportListItem extends ReportListItem {
   constructor() {
      super({
         id: faker.datatype.number( 100 ),
         owner_name: faker.name.findName(),
         last_updated: faker.date.past().toISOString(),
         name: faker.company.catchPhrase(),
         shared: faker.datatype.boolean(),
         owned: faker.datatype.boolean(),
         pinned: faker.datatype.boolean(),
      });
   }
}
